import Axios from 'axios-observable';
import {map} from "rxjs/operators";
import {Exhibitor} from "@/entities/Exhibitor";
import {Observable} from "rxjs/dist/types";
import {ExhibitorFilter} from "@/entities/ExhibitorFilter";
import {ExhibitorContainer} from "@/entities/ExhibitorContainer";
import langHelper from "@/locales/langHelper";
import {Product} from "@/entities/Product";
import {Theme} from '@/entities/Theme';
import {ProductContainer} from '@/entities/ProductContainer';
import {isDefined} from '@/utils';

const qs = require('qs');

export class Services {


  private static readonly userName = 'eyeupdate';
  private static readonly password = 'tawzN6';


  private static readonly backendUrl = process.env.VUE_APP_BACKEND_URL;
  private static readonly project = process.env.VUE_APP_PROJECT;

  static getExhibitorFilters(): Observable<ExhibitorFilter> {
    return Axios.get<ExhibitorFilter>(`${this.backendUrl}/${langHelper.getCurrentLang()}/${this.project}/exhibitorFilters`)
      .pipe(map((data: any) => {
        return new ExhibitorFilter(data.data);
      }));
  }

  static getExhibitors(): Observable<ExhibitorContainer> {
    return Axios.get<ExhibitorContainer>(`${this.backendUrl}/${langHelper.getCurrentLang()}/${this.project}/exhibitors`, {
      params: {
        columns: JSON.stringify(['ID', 'NAME', 'ADRESSE', 'LAND', 'LOGO', 'PLZ', 'STADT', 'WEB', 'EMAIL', 'INFO', 'TELEFON', 'S_ORDER', 'STAND', 'HALLE'])
      },
      paramsSerializer: params => {
        return qs.stringify(params, {arrayFormat: "comma"});
      }
    }).pipe(map((data: any) => {
      let exhibitors = [];
      let themes = [];
      for (const e of data.data.exhibitors) {
        exhibitors.push(new Exhibitor(e, data.data.path));
      }
      if (data.data.exhibitorThemes) {
        for (const t of data.data.exhibitorThemes) {
          themes.push(new Theme(t));
        }
      }
      themes.sort(((a: Exhibitor, b: Exhibitor) => {
        return a.sortOrder.localeCompare(b.sortOrder);
      }));
      exhibitors.sort(((a: Exhibitor, b: Exhibitor) => {
        return a.sortOrder.localeCompare(b.sortOrder);
      }));
      return new ExhibitorContainer(exhibitors, themes);
    }));
  }

  static getProducts(): Observable<ProductContainer> {
    return Axios.get<ProductContainer>(`${this.backendUrl}/${langHelper.getCurrentLang()}/${this.project}/products`, {
      params: {
        columns: JSON.stringify(['INFO', 'S_ORDER', 'TITEL', 'FIRMA_ID', 'UNTERTITEL', 'BILDER', 'BILDER_VERSIONEN', 'BILDER_TEXTE'])
      },
      paramsSerializer: params => {
        return qs.stringify(params, {arrayFormat: "comma"});
      }
    }).pipe(map((data: any) => {
      let products = [];
      let themes = [];
      for (const e of data.data.products) {
        products.push(new Product(e, data.data.path, data.data.picturePath));
      }
      if (isDefined(data.data.productThemes)) {
        for (const t of data.data.productThemes) {
          themes.push(new Theme(t));
        }
      }
      themes.sort(((a: Theme, b: Theme) => {
        return a.sortOrder.localeCompare(b.sortOrder);
      }));
      products.sort(((a: Product, b: Product) => {
        return a.sortOrder.localeCompare(b.sortOrder);
      }));
      return new ProductContainer(products, themes);
    }));
  }

  static sendErrorMessage(error) {
    if (error && error.message && error.message === 'Network Error') {
      return;
    }
    console.log(error)
    if (location.hostname !== 'localhost') {
      console.log("Send Error Message")
      Axios.post('https://i.eyeled.de/eccpack/getDumps.php', JSON.stringify(error, null, 2), {
        params: {
          name: `web_exhibitor_list_${process.env.VUE_APP_PROJECT}_`
        },
        auth: {
          username: Services.userName,
          password: Services.password
        }
      }).subscribe()
    }
  }

}
